import { useTranslation } from 'react-i18next';

import { ConfirmActionModal } from '@/components/common';

interface SendOfferModalProps {
  opened: boolean;
  offerLabel: string;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
  isPaused?: boolean;
}

export const SendOfferModal = ({
  opened,
  offerLabel,
  onClose,
  onConfirm,
  loading,
  isPaused
}: SendOfferModalProps) => {
  const { t } = useTranslation();

  return (
    <ConfirmActionModal
      opened={opened}
      onClose={onClose}
      onConfirm={onConfirm}
      loading={loading}
      isPaused={isPaused}
      title={t('offerDetail.sendModalTitle')}
      message={t('offerDetail.sendModalMessage', { number: offerLabel })}
      confirmLabel={t('offerDetail.sendModalConfirm')}
    />
  );
};
